import { ref, watch } from "vue";

/**
 * One-shot signal: resolves once the project dashboard has loaded and its anchors exist in the DOM.
 * Same shape as useProjectsPageReadySignal.ts.
 */
const isReady = ref(false);

export function markProjectDashboardReady(): void {
  isReady.value = true;
}

export function resetProjectDashboardReady(): void {
  isReady.value = false;
}

export function waitForProjectDashboardReady(): Promise<void> {
  if (isReady.value) return Promise.resolve();

  return new Promise<void>((resolve) => {
    const stop = watch(isReady, (ready) => {
      if (ready) {
        stop();
        resolve();
      }
    });
  });
}
